/* eslint-disable no-undef */
import { getVersion } from '@/assets/js/native'
import { post } from '@/assets/js/json'

export function check () {
  post('/api/member/index/hot/update').then((res) => {
    if (res.data.success) {
      let version = res.data.data.version
      let url = res.data.data.url
      getVersion().then((curVersion) => {
        if (Number(version) > Number(curVersion)) {
          downWgt(url)
        }
      })
    }
  })
}

function downWgt (url) {
  // plus.nativeUI.showWaiting('正在更新中...')
  plus.downloader.createDownload(url, {filename: '_doc/update/'}, function (d, status) {
    if (status === 200) {
      installWgt(d.filename) // 安装wgt包
    } else {
      // plus.nativeUI.alert('下载更新文件失败！')
    }
    // plus.nativeUI.closeWaiting()
  }).start()
}

// 更新应用资源
function installWgt (path) {
  // plus.nativeUI.showWaiting('正在安装更新成功...')
  plus.runtime.install(path, {}, function () {
    // plus.nativeUI.closeWaiting()
    plus.nativeUI.confirm('更新完成,是否重启App?', function (e) {
      if (e.index === 1) {
        plus.runtime.restart()
      }
    }, '提示', ['取消', '确定'])
  }, function (e) {
    // plus.nativeUI.closeWaiting()
    // console.log('安装更新文件失败！')
    // plus.nativeUI.alert('安装更新文件失败！')
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/checkUpdate.js